const callAll = <P extends any[]>(...fns: Array<(...a: P) => void>) => (...args: P) => fns.forEach(fn => fn && fn(...args));

export default callAll;
